// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitoring {
  position: relative;
  width: 100%;
  padding: 24px 0 0;
  margin-bottom: 56px;
}
.monitoring .more-planning {
  text-align: center;
  margin-bottom: 30px;
}
.monitoring .more-planning button {
  color: var(--sebrae-blue-7);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
}
.monitoring .list-planning, .monitoring .archived-planning {
  position: relative;
}
.monitoring .list-planning .wrapper-loading-small, .monitoring .archived-planning .wrapper-loading-small {
  height: 100%;
}
.monitoring .list-planning .accordion-section, .monitoring .archived-planning .accordion-section {
  margin: 24px 0;
}
.monitoring .list-planning .empty, .monitoring .archived-planning .empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-size: 13px;
  color: var(--sebrae-gray);
  padding: 50px 0;
}
.monitoring .archived-planning .accordion {
  padding: 10px;
}
.monitoring .archived-planning .accordion-title {
  font-size: 14px;
}
@media screen and (min-width: 768px) {
  .monitoring .archived-planning .accordion {
    padding: 15px;
  }
  .monitoring .archived-planning .accordion-title {
    font-size: 16px;
  }
}
.monitoring__modal .wrapper-modal.square {
  max-width: 564px;
  max-height: 360px;
  padding: 0;
  border-radius: 4px;
  border-width: 2px;
}
.monitoring__modal .btn-close {
  top: 24px;
  right: 24px;
}
.monitoring__modal .modal-header {
  margin: 0;
  padding: 16px 16px 20px;
}
.monitoring__modal .title {
  padding-bottom: 0;
  color: #243342;
  font-size: 23px;
  font-weight: 700;
  line-height: 1.4;
}
.monitoring__modal .modal-body {
  padding: 24px;
}
.monitoring__modal-content {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.monitoring__modal-content p {
  margin: 0;
  color: var(--sebrae-dark-gray2);
  font-size: 16px;
  font-weight: 700;
}
.monitoring__modal-loading {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.monitoring__modal-list {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.monitoring__modal-list label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.monitoring__modal-list label input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.monitoring__modal-list label input:checked + .monitoring-page__modal-radio::after {
  transform: scale(1);
}
.monitoring__modal-radio {
  width: 14px;
  height: 14px;
  min-width: 14px;
  border-radius: 50%;
  border: 1px solid #b2becd;
  position: relative;
}
.monitoring__modal-radio::after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3b63f3;
  position: absolute;
  top: 2px;
  left: 2px;
  transform: scale(0);
  transition: transform 0.2s ease;
}
.monitoring__modal-actions {
  width: 100%;
  max-width: 108px;
  align-self: flex-end;
}
.monitoring__modal-actions .primary-btn {
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(59, 99, 243, 0.28);
}
.monitoring__modal-actions .button-text {
  font-size: 16px;
  font-weight: 400;
}
@media screen and (max-width: 767px) {
  .monitoring__modal .wrapper-modal.square {
    max-width: 100%;
  }
}
@media screen and (min-width: 768px) {
  .monitoring .card-status-wrapper {
    max-width: 445px;
  }
}
@media screen and (min-width: 1280px) {
  .monitoring .card-status-wrapper {
    max-width: 574px;
  }
  .monitoring .card-status-progress {
    max-width: 240px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/monitoring/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;AACJ;AACI;EACE,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AACN;AAEE;EACE,kBAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAEI;EACE,cAAA;AAAN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAAN;AAII;EACE,aAAA;AAFN;AAII;EACE,eAAA;AAFN;AAKI;EACE;IACE,aAAA;EAHN;EAKI;IACE,eAAA;EAHN;AACF;AAOI;EACE,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AALN;AAOI;EAGE,SAAA;EACA,WAAA;AAPN;AASI;EACE,SAAA;EACA,uBAAA;AAPN;AASI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAPN;AASI;EACE,aAAA;AAPN;AASI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAPN;AASM;EACE,SAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAPR;AAUI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARN;AAUI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AARN;AAUM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AARR;AAUQ;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AARV;AAWQ;EACE,mBAAA;AATV;AAaI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAXN;AAaM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,+BAAA;AAXR;AAcI;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;AAZN;AAcM;EACE,iBAAA;EACA,kBAAA;EACA,+CAAA;AAZR;AAeM;EACE,eAAA;EACA,gBAAA;AAbR;AAiBI;EACE;IACE,eAAA;EAfN;AACF;AAmBE;EACE;IACE,gBAAA;EAjBJ;AACF;AAmBE;EACE;IACE,gBAAA;EAjBJ;EAoBI;IACE,gBAAA;EAlBN;AACF","sourcesContent":[".monitoring {\n  position: relative;\n  width: 100%;\n  padding: 24px 0 0;\n  margin-bottom: 56px;\n\n  .more-planning {\n    text-align: center;\n    margin-bottom: 30px;\n\n    button {\n      color: var(--sebrae-blue-7);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n  }\n  .list-planning, .archived-planning {\n    position: relative;\n\n    .wrapper-loading-small {\n      height: 100%;\n    }\n    .accordion-section {\n      margin: 24px 0;\n    }\n    .empty {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 15px;\n      font-size: 13px;\n      color: var(--sebrae-gray);\n      padding: 50px 0;\n    }\n  }\n  .archived-planning {\n    .accordion {\n      padding: 10px;\n    }\n    .accordion-title {\n      font-size: 14px;\n    }\n\n    @media screen and (min-width: 768px) {\n      .accordion {\n        padding: 15px;\n      }\n      .accordion-title {\n        font-size: 16px;\n      }\n    }\n  }\n  &__modal {\n    .wrapper-modal.square {\n      max-width: 564px;\n      max-height: 360px;\n      padding: 0;\n      border-radius: 4px;\n      border-width: 2px;\n    }\n    .btn-close {\n      // top: 18px;\n      // right: 18px;\n      top: 24px;\n      right: 24px;\n    }\n    .modal-header {\n      margin: 0;\n      padding: 16px 16px 20px;\n    }\n    .title {\n      padding-bottom: 0;\n      color: #243342;\n      font-size: 23px;\n      font-weight: 700;\n      line-height: 1.4;\n    }\n    .modal-body {\n      padding: 24px;\n    }\n    &-content {\n      display: flex;\n      flex-direction: column;\n      gap: 18px;\n\n      p {\n        margin: 0;\n        color: var(--sebrae-dark-gray2);\n        font-size: 16px;\n        font-weight: 700;\n      }\n    }\n    &-loading {\n      min-height: 120px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    &-list {\n      overflow: hidden;\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      label {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        cursor: pointer;\n\n        input {\n          position: absolute;\n          opacity: 0;\n          pointer-events: none;\n        }\n\n        input:checked + .monitoring-page__modal-radio::after {\n          transform: scale(1);\n        }\n      }\n    }\n    &-radio {\n      width: 14px;\n      height: 14px;\n      min-width: 14px;\n      border-radius: 50%;\n      border: 1px solid #b2becd;\n      position: relative;\n\n      &::after {\n        content: \"\";\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        background: #3b63f3;\n        position: absolute;\n        top: 2px;\n        left: 2px;\n        transform: scale(0);\n        transition: transform 0.2s ease;\n      }\n    }\n    &-actions {\n      width: 100%;\n      max-width: 108px;\n      align-self: flex-end;\n\n      .primary-btn {\n        padding: 8px 12px;\n        border-radius: 4px;\n        box-shadow: 0 2px 8px 0 rgba(59, 99, 243, 0.28);\n      }\n\n      .button-text {\n        font-size: 16px;\n        font-weight: 400;\n      }\n    }\n\n    @media screen and (max-width: 767px) {\n      .wrapper-modal.square {\n        max-width: 100%;\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .card-status-wrapper {\n      max-width: 445px;\n    }\n  }\n  @media screen and (min-width: 1280px) {\n    .card-status-wrapper {\n      max-width: 574px;\n    }\n    .card-status {\n      &-progress {\n        max-width: 240px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
